import React from "react";
import moment from "moment";
import SectionLayout, { DataField } from "./SectionLayout";

const NokDisplay = ({ loanRequest }) => {
  return (
    <SectionLayout title="Next of Kin Information">
      <DataField label="Full Name" value={loanRequest.nok_name} />
      <DataField label="Phone Number" value={loanRequest.nok_phone} />
      <DataField
        label="Date of Birth"
        value={loanRequest.nok_dob && moment(loanRequest.nok_dob).format("Do MMMM YYYY")}
      />
      <DataField label="Relationship" value={loanRequest.nok_relationship} />
      <DataField label="Email Address" value={loanRequest.nok_email} />
      <DataField label="Occupation" value={loanRequest.nok_occupation} />
      <DataField label="Place of Work" value={loanRequest.nok_place_of_work} />
      <DataField label="Office Number" value={loanRequest.nok_office_phone} />
      <DataField label="Office Address" value={loanRequest.nok_office_address} />
    </SectionLayout>
  );
};

export default NokDisplay;
